import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getTransactionsPath = () => urlHelper('/transactions');
